import Sessions from "./SessionsPass.container";

export default Sessions;

